module.exports = {
  SERVER_HOST: `${process.env.REACT_APP_NODE_SERVER_HOST}`,
  ENV: `${process.env.REACT_APP_ENV}`,
  PRODUCTION: "production"
}